import apiService from './apiService';

export const getTempOpInstruction = async (page = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      per_page: '1000',
      page: String(page),
    });

    // correct query format: filter[search]
    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/temporary-operating-instructions?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching temporary-operating-instructions:', error);
    throw error;
  }
};

export const getTempOpInstructionDetail = async (id: number | string) => {
  try {
    const response = await apiService.get(`temporary-operating-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching temporary-operating-instructions:', error);
    throw error;
  }
};

export const deleteTempOpInstruction = async (id: number | string) => {
  try {
    const response = await apiService.delete(`temporary-operating-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting temporary-operating-instruction:', error);
    throw error;
  }
};

export const getSystemEngineers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=6');

    return response.data;
  } catch (error) {
    console.error('Error fetching System engineers:', error);
    throw error;
  }
};

export const notifySystemEngineer = async (id: string | number, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/notify-instruction-add`, {
      ...payload,
    });

    return response.data;
  } catch (error) {
    console.error('Error notifying System engineer:', error);
    throw error;
  }
};

export const markInstructionAdd = async (id: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/temporary-operating-instructions/${id}/mark-instruction-added`, payload);

    return response.data;
  } catch (error) {
    console.error('Error marking instruction as added:', error);
    throw error;
  }
};

export const getSectionHead = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=7');
    return response.data;
  } catch (error) {
    console.error('Error fetching Section Head:', error);
    throw error;
  }
};

export const getTechnicalManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=8');
    return response.data;
  } catch (error) {
    console.error('Error fetching Technical managers:', error);
    throw error;
  }
};

export const getOperationsManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');
    return response.data;
  } catch (error) {
    console.error('Error fetching Operations managers:', error);
    throw error;
  }
};

export const getShiftSupervisors = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=2');
    return response.data;
  } catch (error) {
    console.error('Error fetching shift supervisors:', error);
    throw error;
  }
};
export const getTOIDownload = async (id: string | number) => {
  try {
    const response = await apiService.get(`temporary-operating-instructions/${id}/download`, {
      responseType: 'blob',
    });
    return response.data; // Blob
  } catch (error) {
    console.error('Error downloading TOI:', error);
    throw error;
  }
};
